import AbstractHTML5Player from '../all/AbstractHTML5Player';

import { PONCONNECT, PONSTOP, PONPAUSE } from '../../devices/all/settings';
import PlayerGetMediaTask from '../../requests/tasks/player/PlayerGetMediaTask';
import RequestManager from '../../requests/RequestManager';
import { SS_MA } from '../../utils/playerConstants';
import Utils from '../../utils/Utils';
import AAF from '../../AAF/AAF';
import * as constant from './../../AAFPlayer/constants';
import asyncPinObserver from './../../AAF/Pin/AsyncPinObserver';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import { isVMayorIgual519 } from '../../AAFPersistenceManager/helpers/Utils';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import Asset from '../../requests/apa/Asset';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';

/* TODO this must not inherit from HTML5 */
class AndroidPlayer extends AbstractHTML5Player {
  constructor() {
    super();

    this.android_media_src = null; // URL to play VOD, with additional params
    this.attr_id_instance = null; // Pip or full
    this.androidPlayInterval = 1; // Seconds between attemps to play (delay/sleep)
    this.androidPlayRetries = 20; // Max number of retries before send error
    this.androidPlayerReady = false; // Android STB behave
    this.androidOnReady = false;
    this.fireOnDurationChange = false;

    this.timeUpdateTimeoutID = null;

    this.prependPip = '';

    this.currentContentTimeOnPause = null;
    this.currentPlayerMedia = null;
    this.styleBackup = null;
    this.isMediaLoaded = false;
    this.canStopPlayer = false;
    this.isNewSource = false;
    this.playerStopped = false;
    this.isVodMedia = false;

    //this.initialCurrentTime = 0; // El current time para comparar si es que hay cambio
    this.seekWindow = null;

    this.currentTime = 0; // El current time normal
    this.previousCurrentTime = 0;
    this.playerStarts = false;

    this.retryIntervalFirstPlaying = 0.8;
    this.retryLimitFirstPlaying = 60;

    this.OCTOLINK1 = 'octoshape://opsqa.octoshape.org/amx/live/flv/ch1/4000k?ts=true';
    this.OCTOLINK2 = 'https://secure-streams.akamaized.net/rt-doc/index1600.m3u8';
    this.OCTOLINK3 = 'http://tvemsnbc-lh.akamaihd.net/i/nbcmsnbc_1@122532/master.m3u8';
    this.OCTOLINK4 = 'octoshape://opsqa.octoshape.org/amx/live/flv/ch2/4000k?ts=true';
    this.OCTOLINK5 = 'https://secure-streams.akamaized.net/rt-usa/index2500.m3u8';
    this.OCTOLINK6 = 'http://nmxlive.akamaized.net/hls/live/529965/Live_1/index.m3u8';
    this.OCTOLINK7 =
      'http://v3plusinfo247hls-i.akamaihd.net/hls/live/218877/v3plusinfo247hls/v3plusinfo247hls_1_1.m3u8';

    this.seekTimeshift = this.seekTimeshift.bind(this);
    this.tryOnFirstTimeshiftSeek = this.tryOnFirstTimeshiftSeek.bind(this);
    this.seekWindow = null;

    this.isSeek = false;
    this.firstLoad = false;

    this.setPlayerMedia = this.setPlayerMedia.bind(this);
  }

  resetTimeUpdate() {
    if (this.timeUpdateTimeoutID) {
      clearTimeout(this.timeUpdateTimeoutID);
    }
  }

  createTimeUpdate() {
    //console.log('[AAF_FWK] [AndroidPlayer] createTimeUpdate');
    this.resetTimeUpdate();
    this.timeUpdateTimeoutID = setInterval(() => {
      // If on pause, return time when user paused content
      if (this.getCurrentPlayerState() === PONPAUSE) {
        this._onTimeUpdate(this.currentContentTimeOnPause);
      } else {
        this.currentContentTime = Math.floor(
          window.AndroidPlayerInterface.getCurrentStreamPosition() / 1000
        );
        this._onTimeUpdate(this.currentContentTime);
      }
    }, 800);
  }

  createTPANotice(notice) {
    // Crea los elementos
    const tpaNoticeContainer = window.document.createElement('div');
    const tpaNoticeContent = window.document.createElement('p');
    const tpaNoticeImage = window.document.createElement('img');

    // Asigna las clases
    tpaNoticeContainer.className = "tpanotice-container";
    tpaNoticeContent.className = "tpanotice-content";
    tpaNoticeImage.className = "tpanotice-image";

    // Asifna el valor a los elementos
    tpaNoticeContent.innerHTML = notice ? notice : '';

    let region = DeviceStorage.getItem('region');
    region = region ? region : '';

    let claroLogo = '';
    const tpaLogoCVRegion = `externalAplication_alert_logo_clarotv_${region}`;
    const tpaLogoCVDefault = 'externalAplication_alert_logo_clarotv';
    
    const claroLogoRegion = Asset.get(tpaLogoCVRegion);
    if(claroLogoRegion === tpaLogoCVRegion) {
      const claroLogoDefault = Asset.get(tpaLogoCVDefault);
      claroLogo = claroLogoDefault;
    }
    else {
      claroLogo = claroLogoRegion;
    }
    
    tpaNoticeImage.src = claroLogo ? claroLogo : '';
    
    // Afrega los elementos hijos al elemento padre
    tpaNoticeContainer.appendChild(tpaNoticeContent);
    tpaNoticeContainer.appendChild(tpaNoticeImage);
    
    // Agrega el elemento padre al contenedor del player
    this._playerContainer.appendChild(tpaNoticeContainer);
  }

  // TODO this is not a fucking HTML5 player
  createMedia(options) {
    console.log('[AndroidPlayer] createMedia', options);

    if (this._isPrepared) return;

    /*if(options.newSource && options.newSource.src) {
  options.newSource = null;
}*/

    this.options = options;
    this.currentPlayerMedia = options;

    this.prependPip = options.isPip ? '_pip' : '_full';
    let vIndex = options.isPip ? 1 : 0;

    this._playerContainer = window.document.createElement('div');
    this._playerContainer.style.backgroundColor = 'transparent';
    this._playerContainer.id = 'Html5PlayerContainer' + this.prependPip;
    this._playerContainer.className = 'Html5PlayerContainer';

    this.rootElement = window.document.getElementById('HTML5VideoWrapper');

    // TODO player background - Call to the parent, set background
    if (options.isTPA) {
      this.setPlayerBackground(options.isTPA.background ? options.isTPA.background : null);
      this.createTPANotice(options.isTPA.notice ? options.isTPA.notice : null);
    }

    if (!this.streamIsImage()) {
      /*  TODO player background
       * this.setPlayerBackground(options.backgroundImage ? options.backgroundImage : null);
       */

      this._playerHTMLTag = window.document.createElement('video');
      this._playerHTMLTag.setAttribute('id', 'Html5Player' + this.prependPip);
      this._playerHTMLTag.className = 'Html5Player';

      this._playerContainer.appendChild(this._playerHTMLTag);
      this.addEventsListeners();
    } else {
      /*  TODO player background
       * this.setPlayerBackground(options.src ? options.src : null);
       */
    }

    if (!this.options.parentWrapper) {
      console.error('[AndroidPlayer] parentWrapper not found');
      return;
    }

    //console.log('[AndroidPlayer] WrapperID: ' + this.options.parentWrapper.id);

    let vWrapper = document.getElementById(this.options.parentWrapper.id);
    vWrapper.appendChild(this._playerContainer);

    this.hide();
    this.createMediaPlayer(options);

    this._isPrepared = true;

    if (!options.isTPA) this.removeBackgroundAndStyle();

    return;
  }

  loadStartOver() {
    console.info('[AndroidSTB Player] loadStartOver');
    try {
      this.android_media_src = this.src;
      // No hay más pip en CV, así que mini a false
      window.AndroidPlayerInterface.setMiniPlayer(false);

      /**
       * Por el momento, 07 07 2022, no hay startover en dash, 
       * se deja el code "como estaba"
       */
      switch (this.options.streamType) {
        case constant.DASHWV:
        case constant.DASHWV_MA:
          window.AndroidPlayerInterface.loadMediaUrlStartOver(
            this.android_media_src,
            this.options.timeshiftData.seektime * 1000,
            this.options.drmInfo.server_url,
            this.options.drmInfo.challenge
            );
          break;
        default:
        if (isVMayorIgual519()) {
          if (this.options.timeshiftData && !isNaN(this.options.timeshiftData.seektime)) {
            this.currentStartOverSeek = this.options.timeshiftData.seektime;
            window.AndroidPlayerInterface.loadMediaUrlStartOver(
              this.android_media_src,
              this.options.timeshiftData.seektime * 1000
            );
          }
          // Por seguridad, se manda la url sin el startover
          else {
            window.AndroidPlayerInterface.loadMediaUrl(this.android_media_src);
          }
        } 
        else {
          window.AndroidPlayerInterface.loadMediaUrl(this.android_media_src);
        }
        break;
      }

      if (this.options && this.options.groupId) {
        this.currentGroupId = this.options.groupId;
      }
      this.isMediaLoaded = true;
      this.removeBackgroundAndStyle();
      this.isTvRunning = true;
      this.canStopPlayer = true;
      this.setPlayerFull();
    }
    catch (error) {
      console.log(error);
    }
  }

  loadCatchup() {
    console.info('[AndroidSTB Player] loadCatchup');
    try {
      let videoOptions = this.currentPlayerMedia;
      videoOptions.playerMedia.group = this.setFakePGMGroup();

      let groupId = Number.parseInt(videoOptions.groupId);
      let playerMedia = JSON.stringify(videoOptions.playerMedia);
      let isTrailer = videoOptions.isTrailer;
      let isLive = videoOptions.isLive;
      let isMA = videoOptions.streamType ? videoOptions.streamType === SS_MA : false;
      window.AndroidPlayerInterface.setMiniPlayer(false);

      switch (this.options.streamType) {
        case constant.DASHWV:
        case constant.DASHWV_MA:
          window.AndroidPlayerInterface.loadMediaUrl(
            this.options.src,
            this.options.drmInfo.server_url,
            this.options.drmInfo.challenge
          );
        break;
        default: 
        this.setPlayerMedia(groupId, 0, isLive, isTrailer, isMA, playerMedia);
        break;
      }

      this.canStopPlayer = true;
      this.isMediaLoaded = true;
    }
    catch (error) {
      console.log(error);
    }
  }

  loadNPVR() {
    console.info('[AndroidSTB Player] loadNPVR');
    try {
      let videoOptions = this.currentPlayerMedia;
      videoOptions.playerMedia.group = this.setFakePGMGroup();

      let groupId = Number.parseInt(videoOptions.groupId);
      let playerMedia = JSON.stringify(videoOptions.playerMedia);
      let isTrailer = videoOptions.isTrailer;
      let isLive = videoOptions.isLive;
      let isMA = videoOptions.streamType ? videoOptions.streamType === SS_MA : false;
      window.AndroidPlayerInterface.setMiniPlayer(false);

      switch (this.options.streamType) {
        case constant.DASHWV:
        case constant.DASHWV_MA:
          window.AndroidPlayerInterface.loadMediaUrl(
            this.options.src,
            this.options.drmInfo.server_url,
            this.options.drmInfo.challenge
          );
        break;
        default: 
        this.setPlayerMedia(groupId, 0, isLive, isTrailer, isMA, playerMedia);
        break;
      }
      this.canStopPlayer = true;
      this.isMediaLoaded = true;
    }
    catch (error) {
      console.log(error);
    }
  }

  loadTV() {
    try {
      this.android_media_src = this.src;
      // No hay más pip en CV, así que mini a false
      window.AndroidPlayerInterface.setMiniPlayer(false);

      switch (this.options.streamType) {
        // Agregar aquí CMAF cuando este disponible
        case constant.DASH_CMAF:
        case constant.DASHWV:
        case constant.DASHWV_MA:
          console.info('[AndroidSTB Player] loadTV - ES dashwv or dash_cmaf');
          window.AndroidPlayerInterface.loadMediaUrl(
            this.android_media_src, 
            this.options.drmInfo.server_url,
            this.options.drmInfo.challenge
          );
        break;
        case constant.SS:
        case constant.SS_MA:
        console.info('[AndroidSTB Player] loadTV - ES smooth streaming');
        window.AndroidPlayerInterface.loadMediaUrl(
          this.android_media_src, 
          this.options.drmInfo.server_url,
          this.options.drmInfo.challenge
        );
        break;
        // Se deja "como estaba": HLS, HLS_KR, etc. cae aquí
        default:
          console.info('[AndroidSTB Player] loadTV - NO dashwv');
          window.AndroidPlayerInterface.loadMediaUrl(this.android_media_src);
        break;
      }

      if (this.options && this.options.groupId) {
        this.currentGroupId = this.options.groupId;
      }
      this.isMediaLoaded = true;
      this.removeBackgroundAndStyle();
      this.isTvRunning = true;
      this.canStopPlayer = true;
      this.setPlayerFull();
    }
    catch (error) {
      console.log(error);
    }
  }

  loadVOD() {
    console.info('[AndroidSTB Player] loadVOD');
    try {
      let videoOptions = this.currentPlayerMedia;
      let groupId = Number.parseInt(videoOptions.groupId);
      let playerMedia = JSON.stringify(videoOptions.playerMedia);
      let isTrailer = videoOptions.isTrailer;
      let isLive = videoOptions.isLive;
      let isMA = videoOptions.streamType ? videoOptions.streamType === SS_MA : false;

      window.AndroidPlayerInterface.setMiniPlayer(false);
      this.setPlayerMedia(groupId, 0, isLive, isTrailer, isMA, playerMedia);
      this.isMediaLoaded = true;  
      this.canStopPlayer = true;
    }
    catch (error) {
      console.log(error);
    }
  }

  loadMusic() {
    console.info('[AndroidSTB Player] loadMusic');
    try {
      window.AndroidPlayerInterface.setMiniPlayer(false);
      console.info('[AndroidPlayer] MUSIC', this.currentPlayerMedia.src);
      this.startingMusic = true;
      window.AndroidPlayerInterface.loadMediaUrl(this.currentPlayerMedia.src);
      this.isMediaLoaded = true;
    }
    catch (error) {
      console.log(error);
    }
  }

  loadMedia() {
    console.info(
      '[AndroidPlayer] loadMedia',
      //'\nthis.options', this.options,
      '\nthis.currentPlayerMedia',
      this.currentPlayerMedia
    );

    if (!this._isPrepared) {
      return false;
    }

    if (this.streamIsImage()) {
      return;
    }

    if (this.options.resume && !this.options.isLive) {
      this.seek_resume = this.options.resume;
    }

    if (this.options.src) {
      this.src = this.options.src; //
    }

    /**
     * En this.options
     * streamContentType: "content_is_vod"
     * streamType: "smooth_streaming_ma"
     */
    switch (this.options.streamContentType) {
      default:
      case constant.AAF_CONTENT_IS_VOD:
        this.loadVOD();
        break;

      case constant.AAF_CONTENT_IS_TV:
        this.loadTV();
        break;
      
      case constant.AAF_CONTENT_IS_STARTOVER:
        this.loadStartOver();
      break;  

      case constant.AAF_CONTENT_IS_CATCHUP:
        this.loadCatchup();
      break;

      case constant.AAF_CONTENT_IS_NPVR:
        this.loadNPVR();
      break;

      case constant.AAF_CONTENT_IS_AUDIO:
      case constant.AAF_CONTENT_IS_RADIO:
      this.loadMusic();
      break;
    }
  }

  createMediaPlayer(options) {
    if (options.isLive && options.src && !this.streamIsAudio()) {
      //console.log('[AndroidPlayer] createMediaPlayer LIVE');

      let isMini = options.isPip;

      if (isMini) {
        window.AndroidPlayerInterface.setMiniPlayer(true);
      } else {
        window.AndroidPlayerInterface.setMiniPlayer(false);
      }

      if (!isMini) {
        try {
          /*
           * This function must not exist. The player must receive just the media and maybe the size also.
           */
          window.AndroidPlayerInterface.startTvPlayerFull();
          console.log('[AndroidPlayer] createMediaPlayer full LIVE');
        } catch (error) {}
      } else {
        try {
          /*
           * This function must not exist. The player must receive just the media and maybe the size also.
           */
          window.AndroidPlayerInterface.startTvPlayerMini();
          console.log('[AndroidPlayer] createMediaPlayer pip LIVE');
        } catch (error) {}
      }
    } else if (this.streamIsAudio()) {
      try {
        /*
         * This function must not exist. The player must receive just the media and maybe the size also
         */
        window.AndroidPlayerInterface.startMusicPlayer();
        console.log('[AndroidPlayer] createMediaPlayer Music Player OK');
      } catch (error) {}
    }
  }

  setPlayerMedia(groupId, contentId, isLive, isTrailer, isMA, playerMedia) {
    console.log('******** setPlayerMedia catchup?');
    if (isVMayorIgual519()) {
      if(this.options && this.options.streamContentType && this.options.streamContentType === constant.AAF_CONTENT_IS_NPVR ){
        window && window.AndroidPlayerInterface && (typeof window.AndroidPlayerInterface.startTvPlayerFull === 'function') && window.AndroidPlayerInterface.startTvPlayerFull();
      }

      // Se agrega un último param para que se indique a android el stream type, así si es hls o hls_kr se levanta exoplayer, de otra forma se sigue por media player
      //public void setPlayerMedia(final int groupId, final int contentId, final boolean isLive, final boolean isTrailer, final boolean isMaEnabled, final String mediaPlayer)
      window.AndroidPlayerInterface.setPlayerMedia(
        groupId,
        contentId,
        isLive,
        isTrailer,
        isMA,
        playerMedia,
        this.options.streamType
      );
    } else {
      window.AndroidPlayerInterface.setPlayerMedia(
        groupId,
        contentId,
        isLive,
        isTrailer,
        isMA,
        playerMedia
      );
    }
  }

  isCurrentMedia() {
    if (this.currentPlayerMedia !== null && this.currentPlayerMedia.src === this.options.src) {
      console.log('[AndroidPlayer] isCurrentMedia same source');
      return true;
    } else {
      return false;
    }
  }

  async tryToPlay(currentTry) {
    if (!this.androidPlayerReady) {
      console.log(
        '[AndroidPlayer] tryToPlay retry number: [' + currentTry + '] not ready yet...'
      );
      if (currentTry >= this.androidPlayRetries) {
        console.error('[AndroidPlayer] err player instance could not initialize');
        return;
      }
      await Utils.sleep(this.androidPlayInterval);

      return this.tryToPlay(++currentTry);
    } else {
      console.info('[AndroidPlayer] tryToPlay retry number: [' + currentTry + '] READY');
      return this.play();
    }
  }

  play() {
    this.consol('[AndroidPlayer] play');

    if (this.streamIsImage()) {
      return;
    }

    if (!this.androidPlayerReady) {
      return this.tryToPlay(1);
    }

    this.hide();

    this.consol(
      '[AndroidPlayer] play this.options.isLive >' + (this.options.isLive ? 'TRUE' : 'FALSE')
    );
    this.consol(
      '[AndroidPlayer] play his.currentPlayerMedia.isLive >' +
      (this.currentPlayerMedia.isLive ? 'TRUE' : 'FALSE')
    );
    if (this.currentPlayerMedia.isLive || this.options.isLive) {
      this.consol('[AndroidPlayer] play en 1');

      var isMini = this.options.isPip;

      if (isMini) {
        this.consol('[AndroidPlayer] play en 2');
        console.log('[AndroidPlayer] CALL MINI LIVE play');
        try {
          window.AndroidPlayerInterface.setMiniPlayer(true);
          window.AndroidPlayerInterface.play();
        } catch (error) {
          console.error('[AndroidPlayer] LIVE play err', error);
        }
      } else {
        this.consol('[AndroidPlayer] play en 3');
        console.log('[AndroidPlayer] CALL FULL LIVE play');
        try {
          window.AndroidPlayerInterface.setMiniPlayer(false);
          window.AndroidPlayerInterface.play();
        } catch (error) {
          console.error('[AndroidPlayer] LIVE play err', error);
        }
      }
    } else if (this.streamIsAudio()) {
      this.consol('[AndroidPlayer] play en 4');
      try {
        console.log('[AndroidPlayer] MUSIC play');
        //window.AndroidPlayerInterface.startMusicPlayer();
        window.AndroidPlayerInterface.play();
      } catch (error) {
        console.error('[AndroidPlayer] MUSIC play err', error);
      }
    } else {
      this.consol('[AndroidPlayer] play en 5');
      try {
        window.AndroidPlayerInterface.play();
        console.log('[AndroidPlayer] VOD play OK');
      } catch (error) {
        console.error('[AndroidPlayer] VOD play err', error);
      }
    }

    this.removeBackgroundAndStyle();

    this.onPlayerStatePlay();
  }

  replaceMediaSource(newSource) {
    console.log(
      '[AndroidPlayer] ===================================================================> replaceMediaSource',
      newSource
    );
    var isNewSourceMA = newSource.streamType ? newSource.streamType === SS_MA : false;
    var isThisSourceMA = this.options.streamType ? this.options.streamType === SS_MA : false;
    this.options.newSource = newSource; // Add the attr to detect error when replace and not reset whole player
    this.options.src = newSource.src;
    this.options.drmInfo = newSource.drmInfo;
    this.options.isLive = newSource.isLive;
    this.options.streamType = newSource.streamType;
    this.options.isPip = newSource.isPip;
    this.options.groupId = newSource.groupId;
    this.options.contentId =
      newSource.drmInfo && newSource.drmInfo.content_id ? newSource.drmInfo.content_id : null;
    var playerMedia = JSON.stringify(newSource.playerMedia);

    this.audioTracks = [];
    this.currentAudioTrackIndex = null;
    this.currentSubtitleTrackIndex = null;

    this.seekWindow = null;

    this.currentTime = 0; // El current time normal
    this.previousCurrentTime = 0;
    this.playerStarts = false;

    this.timeshiftData = null;

    this.isSeek = false;

    this.currentStartOverSeek = null;
    this.currentGroupId = null;

    if (!this.streamIsAudio()) {
      asyncPinObserver.fire('player_stop');
    }

    this.resetProgressForTimeshift();
    this.resetFastForwardRewind();

    // If there is a resume when vod...
    if (newSource.resume && !newSource.isLive) {
      this.seek_resume = newSource.resume;
      this.options.resume = newSource.resume;
    }

    if (this.options.isLive && !this.streamIsAudio()) {
      if (newSource.timeshift) {
        this.timeshift = newSource.timeshift;
      }

      try {
        if (this.options.isPip) {
          window.AndroidPlayerInterface.setMiniPlayer(true);
          console.log('[AndroidPlayer] replaceMediaSource LIVE - MINI ');
        } else {
          window.AndroidPlayerInterface.setMiniPlayer(false);
          this.setPlayerFull();
          console.log('[AndroidPlayer] replaceMediaSource LIVE - FULL ');
        }
        this.isVodMedia = false;
        //Hardcoded channel
        switch (this.android_media_src) {
          case this.OCTOLINK1:
            this.android_media_src = this.OCTOLINK2;
            break;
          case this.OCTOLINK2:
            this.android_media_src = this.OCTOLINK3;
            break;
          case this.OCTOLINK3:
            this.android_media_src = this.OCTOLINK4;
            break;
          case this.OCTOLINK4:
            this.android_media_src = this.OCTOLINK5;
            break;
          case this.OCTOLINK5:
            this.android_media_src = this.OCTOLINK6;
            break;
          case this.OCTOLINK6:
            this.android_media_src = this.OCTOLINK7;
            break;
          case this.OCTOLINK7:
            this.android_media_src = this.OCTOLINK1;
            break;

          default:
            this.android_media_src = this.OCTOLINK1;
        }

        this.android_media_src = this.options.src;
        window.AndroidPlayerInterface.loadMediaUrl(this.android_media_src);

        this.isNewSource = true;
        this.isMediaLoaded = true;

        this.androidPlayerReady = false;

        this.removeBackgroundAndStyle();

        this.onPlayerStateStop();
      } catch (error) {
        console.log('[AndroidPlayer] replaceMediaSource err', error);
      }
    } else if (!this.streamIsAudio()) {
      try {
        if (this.options.isPip) {
          window.AndroidPlayerInterface.setMiniPlayer(true);
          console.log('[AndroidPlayer] replaceMediaSource VOD - PIP ');
        } else {
          window.AndroidPlayerInterface.setMiniPlayer(false);
          console.log('>>>>>>>>>>@@@@@@@@ replaceMediaSource VOD - FULL ');
        }

        this.isVodMedia = true;

        if (isNewSourceMA && isThisSourceMA) {
          // de multiple audio a multiple no recargamos el player
          this.play();
        } else {
          // de multiple audio a single audio o vicervesa o de single a single, recargamos el player
          this.setPlayerMedia(
            this.options.groupId,
            0,
            this.options.isLive,
            this.options.isTrailer,
            isNewSourceMA,
            playerMedia
          );
        }

        this.isNewSource = true;
        this.isMediaLoaded = true;
        this.androidPlayerReady = false;
        this.removeBackgroundAndStyle();
        this.onPlayerStateStop();
      } catch (error) {
        console.log('[AndroidPlayer] replaceMediaSource ERROR', error);
      }
    } else if (this.streamIsAudio()) {
      console.info('[AndroidPlayer] replaceMediaSource MUSIC', this.currentPlayerMedia.src);
      window.AndroidPlayerInterface.setMiniPlayer(false);
      window.AndroidPlayerInterface.loadMediaUrl(this.options.src);
      this.isNewSource = true;
      this.isMediaLoaded = true;
      this.isVodMedia = true;

      this.androidPlayerReady = false;

      this.removeBackgroundAndStyle();
    }
  }

  playNewSource() {
    console.log('[AndroidPlayer] playNewSource', this.currentPlayerMedia);
    var isMini = this.options.isPip;
    if (isMini) {
      window.AndroidPlayerInterface.setMiniPlayer(true);
    } else {
      window.AndroidPlayerInterface.setMiniPlayer(false);
    }

    if (this.options.isLive || (this.streamIsAudio() && !this.isVodMedia)) {
      try {
        if (isMini) {
          window.AndroidPlayerInterface.play();
          console.log('[AndroidPlayer] playNewSource MINI play Started');
        } else {
          window.AndroidPlayerInterface.play();
          console.log('[AndroidPlayer] playNewSource FULL play Started');
        }

        this.androidPlayerReady = true;

        this.removeBackgroundAndStyle();
      } catch (error) {
        console.log('[AndroidPlayer] playNewSource - Play err', error);
      }
    } else {
      try {
        window.AndroidPlayerInterface.play();
        console.log('[AndroidPlayer] playNewSource FULL VOD play Started');

        this.androidPlayerReady = true;

        this.removeBackgroundAndStyle();
      } catch (error) {
        console.log('[AndroidPlayer] playNewSource VOD Play err', error);
      }
    }
  }

  async requestPlayerGetMedia(
    groupId = '',
    contentId = '',
    isTrailer = false,
    streamType = '',
    startTime = '',
    endTime = ''
  ) {
    let result;
    try {
      const playerGetMediaTask = new PlayerGetMediaTask(
        groupId,
        contentId,
        isTrailer,
        streamType,
        startTime,
        endTime
      );
      result = await RequestManager.addRequest(playerGetMediaTask);
    } catch (err) {
      console.error('[AndroidPlayer] Error calling playerGetMedia: ', err);
      result = err;
    }
    return new Promise((resolve, reject) => {
      if (result.status == '200') {
        resolve(result.response);
      } else {
        reject(result);
      }
    });
  }

  removeBackgroundAndStyle() {
    this.setPlayerBackground(null);
    let root = document.getElementById('root');
    if (this.styleBackup === null) {
      this.styleBackup = {
        background: root.style.background,
        backgroundColor: root.style.backgroundColor,
        backgroundImage: root.style.backgroundImage
      };
    }
    //this.styleBackup = root.style;
    //console.log('******* <<<<<<<<<<< INIT COSHIP Web Root Style');
    //console.log(this.styleBackup);
    //console.log(root.style);
    root.style.background = 'transparent';
    root.style.backgroundColor = 'transparent';
    root.style.backgroundImage = 'none';
  }

  resume() {
    console.log('[AndroidPlayer] resume');
    if (this.isMediaLoaded && !this.streamIsAudio()) {
      this.currentContentTimeOnPause = null;
      window.AndroidPlayerInterface.play();
      this.onPlayerStatePlay();
    } else if (this.streamIsAudio()) {
      window.AndroidPlayerInterface.play();
      this.onPlayerStatePlay();
    }
  }

  pause() {
    console.log('[AndroidPlayer] pause');
    if (this.isMediaLoaded) {
      // Save current time (for duration)...
      this.currentContentTimeOnPause = this.getCurrentTime();
      window.AndroidPlayerInterface.pause();
      this.onPlayerStatePause();
      this.resetFastForwardRewind(true);
    }
  }

  stop() {
    console.log('[AndroidPlayer] stop CALLED');
    if (this.streamIsAudio()) {
      console.log('[AndroidPlayer] stop CALLED but is Music dont stop');
      return;
    } else {
      if (this.options.isPip) {
        try {
          window.AndroidPlayerInterface.stop();
          this.playerStopped = true;
        } catch (error) {
          console.error(error);
        }
        this.onPlayerStateStop();
        this.androidPlayerReady = false;
      } else {
        this.resetFastForwardRewind();
        try {
          window.AndroidPlayerInterface.stop();
          this.playerStopped = true;
        } catch (error) {
          console.error('[AndroidPlayer] stop err', error);
        }
        this.onPlayerStateStop();
        this.androidPlayerReady = false;
      }
    }
  }

  hide() {
    if (this._playerHTMLTag) {
      this._playerHTMLTag.style.visibility = 'hidden';
    }
  }

  show() {
    console.log('[AndroidPlayer] show');
    if (this._playerHTMLTag) {
      this._playerHTMLTag.style.visibility = 'visible';
    }
  }

  seekStartOver(seekTime) {
    this.consol('PAU> AndroidPlayer > seekStartOver, seekTime: ' + seekTime);
    this.currentStartOverSeek = seekTime;
    this.nowStartOverSeek = Utils.nowAsTimestampSeconds();

    this.consol('[ANDROID PLAYER] doing seekTime to 3', seekTime);
    this.seek(seekTime);
    if (this.options.events.onSeekStartOver) {
      this.options.events.onSeekStartOver(seekTime);
    }
  }

  /**
   *  @param timeshiftData = {
   *    backward: isBackward,
   *    // Si es negativo o no, se verifica en video/component, quien es quien decide
   *    // si se va o no a pgm o solo hace seek sobre el actual playing
   *    seektime: second to go to,
   *    maxtimeshiftallowed,
   *    starttime: tiempo inicial en que se pidió el request a getmedia
   *  };
   *
   * @param firstSeek true => se tiene que esperar hasta que el player inicie el playing y luego de esto, se manda el seek.
   *                  false => el player ya esta playeando, sobre el playing se manda el seek (no se espera por el playing).
   */
  // Based on currentTime
  seekTimeshift(timeshiftData, firstSeek) {
    if (!EventTimeshift.isEnabled()) {
      console.info(
        '[ANDROID PLAYER] seekTimeshift <timeshiftData, firstSeek, seekWindow> ',
        timeshiftData,
        firstSeek,
        this.seekWindow
      );
      if (firstSeek) {
        this.tryOnFirstTimeshiftSeek(1, timeshiftData);
      } else {
        // Calc seek
        //let seekTime = timeshiftData.seektime;

        const now = Utils.now(true).unix();
        let seekTime = Math.floor(
          timeshiftData.maxtimeshiftallowed - timeshiftData.seektime
        );
        // if(this.seekWindow.lastseek !== null) {
        //   const diff = Math.ceil(now - this.seekWindow.lastseek);
        //   console.log('[ANDROID PLAYER] function timeshift diff calculado, segundos: ', diff)
        //   seekTime = seekTime - diff;
        // }

        // starttime viene siempre en 1 :/
        if (this.seekWindow && this.seekWindow.startTime >= 0) {
          if (seekTime <= 1) {
            seekTime = 1; // 1 seconds, protect player, contents start second 6 aprox? average
          }
        }

        if (this.seekWindow && !this.seekWindow.lastseek) this.seekWindow.lastseek = now;

        setTimeout(() => {
          console.log('[ANDROID PLAYER] doing seekTime to 3', seekTime);
          this.seek(seekTime);
        }, 4000);
      }
    }
  }

  async tryOnFirstTimeshiftSeek(currentTry, timeshiftData) {
    if (!EventTimeshift.isEnabled()) {
      let curTime = this.getCurrentTime();
      console.log(
        '[ANDROID PLAYER]> tryOnFirstTimeshiftSeek retry number: [' +
        currentTry +
        '], curTime: ' +
        curTime
      );
      if (isNaN(curTime)) {
        curTime = 0;
      }
      if (curTime <= 0) {
        console.log(
          '[ANDROID PLAYER]> tryOnFirstTimeshiftSeek retry number: [' + currentTry + ']'
        );
        if (currentTry >= this.retryLimitFirstPlaying) {
          throw new Error('Fail to get playing state');
          console.log('[ANDROID PLAYER]> Error, Fail to get playing state');
          return;
        }
        await Utils.sleep(this.retryIntervalFirstPlaying);

        return this.tryOnFirstTimeshiftSeek(++currentTry, timeshiftData);
      } else {
        this.seekWindow = {
          startTime: 1, // & seconds, its enough to protect player ¿?
          // 1.- Parece que Kaon y huawei regresan duration = maxtimeshiftallowed
          // 2.- coship, creo regresa el dato en currenttime
          // Validar 1 y 2
          endTime: this.getDuration() > 0 ? this.getDuration() : 0,
          duration: this.getDuration(),
          lastseek: null
        };
        console.log(
          '[ANDROID PLAYER]> yendo a seekTimeshift, getDuration, currentTime ',
          this.getDuration(),
          this.getCurrentTime(),
          this.seekWindow
        );

        return this.seekTimeshift(timeshiftData, false);
      }
    }
  }

  seek(seconds) {
    //console.log('[TSPR-PLAYER]-PAU android/player se hará seek al segundo: ' + seconds);
    this.isSeek = true;
    this.skip(seconds);
  }

  skip(seconds) {
    let boundaryTime = 1;
    let positionCommandData = {};
    const timePosition = Math.floor(seconds * 1000);
    //console.log('[TSPR-PLAYER]-PAU android/player se hace seek al segundo: ' + seconds);
    window.AndroidPlayerInterface.seekTo(timePosition);
  }

  destroy() {
    console.log(
      '[AndroidPlayer] Destroy called',
      '\nisPrepared',
      this._isPrepared,
      '\ncanStop: ',
      this.canStopPlayer,
      '\noptions: ',
      this.options,
      '\ncurrentPlayerMedia: ',
      this.currentPlayerMedia
    );

    if (!this._isPrepared) {
      console.log('[AndroidPlayer] NOT PREPARED so WAIT');
      return;
    }

    /*
if(this.streamIsAudio())
  return super.destroy();
*/

    if (!this.streamIsAudio()) {
      asyncPinObserver.fire('player_stop');
    }

    this.stopAndQuit();

    // remove listeners before destroy instance player
    this.removeEventsListener();

    this.isMediaLoaded = false;

    //window.AndroidPlayerInterface = null;
    this.android_media_src = null;

    this._duration = 0;
    this.currentContentTime = 0;
    this.seek_resume = 0;
    this.src = null;

    this.currentTime = 0; // El current time normal
    this.previousCurrentTime = 0;
    this.playerStarts = false;

    this.seekWindow = null;
    this.currentGroupId = null;
    this.isSeek = false;

    this.currentStartOverSeek = null;
    this.resetProgressForTimeshift();
    this.resetFastForwardRewind();

    if (this.styleBackup !== null) {
      let root = document.getElementById('root');
      root.style.background = this.styleBackup.background;
      root.style.backgroundColor = this.styleBackup.backgroundColor;
      root.style.backgroundImage = this.styleBackup.backgroundImage;
    }

    this.resetTimeUpdate();

    //Destroy Playback Container
    if (this._playerContainer) {
      if (this._playerHTMLTag && this._playerHTMLTag.parentNode) {
        this._playerHTMLTag.parentNode.removeChild(this._playerHTMLTag);
      }
      let vWrapper = document.getElementById(this.options.parentWrapper.id);
      vWrapper.removeChild(this._playerContainer);
      this._playerContainer = null;
      this._playerHTMLTag = null;
    }

    this._isPrepared = false;

    this.fireOnDurationChange = false;

    // Call to the parent...
    this.setPlayerBackground(null);

    this.previousPlayerState = PONCONNECT;
    this.currentPlayerState = PONCONNECT;
    this.timeshift = null;

    return;
  }

  itsSameMedia() {
    if (
      this.currentPlayerMedia !== null &&
      this.currentPlayerMedia.src === this.options.src &&
      this.currentPlayerMedia.streamType === this.options.streamType
    ) {
      return true;
    } else {
      return false;
    }
  }

  stopAndQuit() {
    console.log('[AndroidPlayer] StopAndQuit CALLED');
    this.onAndroidTrackInfoEvent({})
    if (this.options && this.options.isPip) {
      try {
        window.AndroidPlayerInterface.stopMiniPlayer();
        console.log('[AndroidPlayer] StopAndQuit PIP OK');
      } catch (error) {
        console.log('[AndroidPlayer] StopAndQuit PIP ERROR');
      }
    } else {
      try {
        window.AndroidPlayerInterface.stopFullPlayer();
        console.log('[AndroidPlayer] StopAndQuit FULL OK');
      } catch (error) {
        console.log('[AndroidPlayer] StopAndQuit FULL ERROR');
      }
    }
    if (this.streamIsAudio()) {
      try {
        window.AndroidPlayerInterface.stop();
      } catch (error) {
        console.log('[AndroidPlayer] StopAndQuit MUSIC ERROR');
      }
    }
  }

  setPlayerFull() {
    this.setPlayerSize(0, 0, 1280, 720);
    // TODO check if we need a pause on player, and object ¿?
    // this.sefPlugin.style.position = "relative or fixed ¿?";
  }

  setPlayerSize(top, left, width, height) {
    console.log(
      '[AndroidPlayer.setPlayerSize] ',
      '\ntop',
      top,
      '\nleft',
      left,
      '\nwidth',
      width,
      '\nheight',
      height
    );

    if (this._playerContainer) {
      this._playerContainer.style.top = top + 'px';
      this._playerContainer.style.left = left + 'px';
      this._playerContainer.style.width = width + 'px';
      this._playerContainer.style.height = height + 'px';
      this._playerContainer.style.position = 'relative';

      this._playerContainer.className = 'androidPlayerContainer'; // We dont use this css...at this moment
    }

    try {
      window.AndroidPlayerInterface.setPlayerSize(width, height, top, left);
    } catch (error) {}

    return this.setPlayerResolution(top, left, width, height);
  }

  setPlayerResolution(top, left, width, height) {
    return;
  }

  addEventsListeners() {
    console.log('[AndroidPlayer] addEventsListeners');

    //console.log(window.AndroidPlayerInterface);
    // Bind first
    this._toBindOnLoad = this._onLoad.bind(this);
    this._toBindOnWaiting = this._onWaiting.bind(this);
    this._toBindOnWaiting = this._onWaiting.bind(this);
    this._toBindOnPlaying = this._onPlaying.bind(this);
    this._toBindOnError = this._onError.bind(this);
    this._toBindOnFinished = this._onFinished.bind(this);
    this._toBindOnCanPlay = this._onCanPlay.bind(this);
    this._toBindOnStreamStarted = this._onStreamStarted.bind(this);
    this._toBindOnBuffering = this._onBuffering.bind(this);
    this._toBindOnLoad = this._onPlayReady.bind(this);
    this._toBindAndroidEvent = this.onAndroidEvent.bind(this);
    this._toBindAndroidTrackInfo = this.onAndroidTrackInfoEvent.bind(this);

    // Add Android listeners
    this.rootElement.addEventListener('AndroidEvent', this._toBindAndroidEvent);
    document.addEventListener('onTrackInfo', this._toBindAndroidTrackInfo);
    
  }

  removeEventsListener() {
    console.log('[AndroidPlayer] removeEventsListener');

    if (this.rootElement) {
      // Remove Android listeners
      this.rootElement.removeEventListener('AndroidEvent', this._toBindAndroidEvent);
      document.removeEventListener('onTrackInfo', this._toBindAndroidTrackInfo);

    }
  }

  /**
   * FIXME. lms/live? reporta currentTime?
   * Esta realmente playeando el player? video en pantalla?
   */
  isPlayerPlaying() {
    console.log(
      '[AAF BLOCKED CHANNELS] Player isPlayerPlaying: ' +
      (this.playerStarts ? 'TRUE' : 'FALSE')
    );
    return this.playerStarts;
  }

  firstTrack() {
    if (this.options.audiosubtitleinfo && this.options.audiosubtitleinfo.audio) {
      console.log('[[MA-LIVE]]-firstTrack');
      // if(MultipleLangLive.isEnabled() && outputParams.isLive){
      //Se agrega función para cambiar idioma/subtítulos en LIVE
      // console.log('[JONY]-Hay parámetros iniciales de audio y subtitle para reproducir ');
      // console.log('[JONY]-outputParams.audiosubtitleinfo.audio=>' +  outputParams.audiosubtitleinfo.audio);
      // console.log('[JONY]-outputParams.audiosubtitleinfo.subtitle=>' + outputParams.audiosubtitleinfo.subtitle);
      const audio = this.options.audiosubtitleinfo.audio;
      this.currentAudioTrackIndex = audio;
      const subtitle = this.options.audiosubtitleinfo.subtitle;
      // this.currentLanguageOptionIDSubtitle = subtitle;
      this.setAudioTrackLive(audio, subtitle);
      // }
    }
  }



  onAndroidTrackInfoEvent(e){
    console.log('[AndroidPlayer] onAndroidTrackInfoEvent', e)
    const {detail : {param = {audios : null, subtitles : null}, event = 'onTrackInfo'} = {}} = e;
    if (event === 'onTrackInfo') {
      const {events : {onTrackInfo = null} = {}} = this.options;
      if (onTrackInfo && Utils.isFunction(onTrackInfo)) {
        const trackInfo = this.getAudioSubtitleLive(param);
        onTrackInfo(trackInfo);
      }
    }
  }

  onAndroidEvent(e) {

    const {detail : {param, event} = {}} = e;
    console.log('[AndroidPlayer.onAndroidEvent]', param, event);

    switch (event) {
      case 'onLoad':
        if (this.isNewSource) {
          this.playNewSource();
        } else {
          this.play();
        }
        this._onLoad(param);
        break;
      case 'onError':
        if (param === 'Request playlist fail') {
          this._onStreamError(param);
        } else {
          this._onError(param);
        }
        break;
      case 'onWaiting':
        this._onWaiting(param);
        break;
      case 'onProgress':
        //console.log('[AAF_FWK_STV] [AndroidPlayer] onAndroidEvent onProgress > ' + Number.parseInt(param));
        const value1 = Number.parseInt(param);

        /// Send observer
        if (this.previousCurrentTime === 0) {
          this.previousCurrentTime = value1;
        } else {
          if (!this.streamIsAudio()) {
            if (!this.playerStarts) {
              this.getNowEvent();
              console.log('[MA-LIVE]----fire');
              asyncPinObserver.fire('player_starts');
              if (
                (this.options.isLive ||
                  this.options.streamContentType ==
                  constant.AAF_CONTENT_IS_CATCHUP) &&
                MultipleLangLive.isGroupIdEnabled(
                  this.options.groupId,
                  this.options.streamType
                )
              ) {
                this.firstTrack();
              }
              this.playerStarts = true;
              if (EventTimeshift.isEnabled()) {
                this.getNowEvent();
              }
            }
          }
        }

        if (value1 >= 0) {
          let parameter = param;
          if (this.startingMusic){
            parameter = 0;
          }
          this._onTimeUpdate(parameter);
        }
        break;
      case 'onBuffering':
        console.log('[AndroidPlayer] onAndroidEvent onBuffering', param);
        this._onBuffering(param);
        break;
      case 'onPlaying':
        this._onPlaying(param);
        break;
      case 'onEnded':
        this._onFinished(param);
        break;
      case 'onReady':
        this.androidPlayerReady = true;
        this.androidOnReady = true;
        break;
      case 'onDurationchange':
        const value2 = Number.parseInt(param);
        if (value2 >= 0) {
          this._onDurationChange(param);
        }
        break;
      case 'onSeek':
        this._onSeek(param);
        break;
      default:
        break;
    }
  }

  _onBufferingStart() {
    this.onPlayerStateBuffer();
    if (this.options.events.onBufferingStart) {
      console.log('Dispatch onBufferingStart ==================> ');
      this.options.events.onBufferingStart();
    }
  }

  _onBufferingFinish() {
    // Prevents android to resume when finish buffering
    if (this.getCurrentPlayerState() === PONPAUSE && this.currentContentTimeOnPause !== null) {
      //window.AndroidPlayerInterface.pause();
    }

    // If stop and ends buffering, nothing to do
    if (this.getCurrentPlayerState() === PONSTOP) {
      return;
    }

    // If current state is on connecting, then we go to play
    if (this.getCurrentPlayerState() === PONCONNECT) {
      this.onPlayerStatePlay();
    } else {
      // Set same state as last
      this.setCurrentPlayerState(this.previousPlayerState);
    }

    if (this.options.events.onBufferingFinish) {
      console.log('[AndroidPlayer] onBufferingFinish');
      this.options.events.onBufferingFinish();
    }
  }

  _onStreamError(param) {
    console.log('[AndroidPlayer] _onStreamError', param);
    let videoOptions = this.options;
    const isMini = videoOptions.isPip;
    const groupId = Number.parseInt(videoOptions.groupId);
    const isTrailer = videoOptions.isTrailer;
    const isLive = videoOptions.isLive;

    let streamType = isLive ? 'hls' : 'smooth_streaming';

    this.requestPlayerGetMedia(groupId, null, isTrailer, streamType).then(response => {
      console.log('[AndroidPlayer] onLoadRequestMedia-RELOAD', response);
      if (response !== null) {
        if (isLive) {
          this.android_media_src = response.media.video_url;
          window.AndroidPlayerInterface.loadMediaUrl(this.android_media_src);
          console.log('[AndroidPlayer] load URL @ FULL LIVE TV OK');
        } else {
          var playerMediaRes = JSON.stringify(response);
          this.setPlayerMedia(groupId, 0, isLive, isTrailer, false, playerMediaRes);
          console.log('[AndroidPlayer] load URL @ FULL VOD OK');
        }

        if (!isMini) {
          this.isMediaLoaded = true;
          this.removeBackgroundAndStyle();
          this.isTvRunning = true;
          this.canStopPlayer = true;
        } else {
          this.isMediaLoaded = true;
          this.removeBackgroundAndStyle();
          this.isTvRunning = true;
          this.canStopPlayer = true;
        }
      } else {
        this.destroy();
      }
    });
  }

  /*
   *   ALL EVENTS;
   */
  _onError(e) {
    console.log('[AndroidPlayer] _onError', e);

    let params = JSON.parse(e);
    let evtType = params.type;
    let error_code = params.description;

    if (this.options.events.onError) {
      this.options.events.onError('[' + error_code + ']' + evtType);
    }
  }

  getCurrentTime() {
    if (EventTimeshift.isEnabled()) {
      if (this.currentLiveEvent) {
        if (this.options.currentContentType === constant.AAF_CONTENT_IS_TV) {
          let now = Utils.nowAsTimestampSeconds();
          if (now > this.currentLiveEvent.date_end) {
            // Pasa al siguiente evento
            this.currentLiveEvent = null;
            this.getNowEvent();
          } else {
            return Math.round(now - this.currentLiveEvent.date_begin);
          }
        }

        if (this.options.currentContentType === constant.AAF_CONTENT_IS_STARTOVER) {
          if (this.currentStartOverSeek !== null) {
            let now = Utils.nowAsTimestampSeconds();
            if (this.nowStartOverSeek === null) {
              this.nowStartOverSeek = now;

              return this.currentStartOverSeek;
            }

            let currentcTime = Math.floor(this.currentTime);
            let dur = this.currentLiveEvent.date_end - this.currentLiveEvent.date_begin;
            const threshold_seconds = 0.25 * 60; // 15 seg antes de que haga el skip to live
            dur = dur - threshold_seconds;

            // Si está en trickMode y llega al borde disponible, salta a live
            let skipByFastForward = false;
            if (!isNaN(this.speed_value)) {
              if (Math.abs(this.speed_value) > 0) {
                let remainTime = now - this.currentLiveEvent.date_begin;
                const threshold_seconds_when_trickmode = 60;
                if (
                  Math.abs(currentcTime - remainTime) <
                  threshold_seconds_when_trickmode
                ) {
                  skipByFastForward = true;
                }
              }
            }

            if (currentcTime > dur || skipByFastForward) {
              this.currentLiveEvent = null;
              if (this.options.events.onSkipToLive) {
                this.options.events.onSkipToLive(this.currentGroupId, {
                  group_id: this.currentGroupId,
                  closePlayerControls: true
                });
              }

              return;
            } else {
              return currentcTime;
            }
          }
        }
      }
    }

    return this.currentTime;
  }

  getDuration() {
    return this._duration;
  }

  setDuration() {
    this._duration = Math.floor(window.AndroidPlayerInterface.getDuration()) / 1000; // If it is live content, duration will be 0
    console.log('[AndroidPlayer] content duration: ' + this._duration);
  }

  doVideoResume() {
    console.log('[AndroidPlayer] sending resume to: ' + this.seek_resume * 1000);
    if (this.seek_resume <= 0) {
      return;
    }

    console.log('[AndroidPlayer] sending resume to: ' + this.seek_resume * 1000);
    let rpos = window.AndroidPlayerInterface.setPosition(this.seek_resume * 1000);
    console.log(rpos);

    // Check on devices if we will require a delay here...
    this.seek_resume = 0;
  }

  /* Events */
  _onPlayReady() {
    console.log('[AndroidPlayer] _onPlayReady');
    this.androidPlayerReady = true;
  }

  _onVideoDetailsChanged(e) {
    console.log('[AndroidPlayer] _onVideoDetailsChanged', e);
  }

  _onLoad(e) {
    this.startingMusic = false;
    // Please sure this method in android must be call once time!
    console.log('[AndroidPlayer] _onLoad', e);
    this._isOnLoaded = true;
    this.androidPlayerReady = true;
    this.canStopPlayer = true;
    //this.options = this.currentPlayerMedia;

    if (this.options.events.onLoad) {
      this.options.events.onLoad(e);
    }
  }

  _onCanPlay(e) {
    console.log('[AndroidPlayer] _onCanPlay', e);
    //console.log(window.AndroidPlayerInterface);
    //this.options = this.currentPlayerMedia;
    this.canStopPlayer = true;

    if (this.options.events.onCanPlay) {
      this.options.events.onCanPlay(e);
    }
    this.timeshift &&
    setTimeout(() => {
      this.skip(0);
    }, 500);
  }

  _onStreamStarted(e) {
    console.log('[AndroidPlayer] _onStreamStarted', e);

    // Content duration is available at this point...
    this.setDuration();

    // Fire on duration change ... and then calculate rolling credits time
    if (this.options.events.onDurationChange && !this.fireOnDurationChange) {
      this.options.events.onDurationChange(e);
      this.fireOnDurationChange = !this.fireOnDurationChange; // only send event once
    }

    // TODO disabled for the moment...time update
    this.createTimeUpdate();
  }

  _onWaiting(e) {
    console.log('[AndroidPlayer] _onWaiting');
    console.log(e);
    if (this.options.events.onWaiting) {
      this.options.events.onWaiting();
    }
  }

  _onTimeUpdate(currentTime) {

    switch (this.options.currentContentType) {
      case constant.AAF_CONTENT_IS_TV:
        if (
          this.ifFireProgressForTimeshift() &&
          AAF.Timeshift.hasTimeshift(this.currentGroupId)
        ) {
          this.currentTime = this.getCurrentTime();
        } else {
          console.log('[androidPLAYER] antes', currentTime);
          this.currentTime = Math.floor(currentTime / 1000);
        }
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
        // 1.- Se settea el tiempo, para que getCurrentTime verifique entre otras cosas si hay que saltar a live
        this.currentTime = Math.floor(currentTime / 1000); //
        // 2.- Si no se hace el salto a live, entonces se regresa y actualiza a lo filtrado por getCurrentTime
        this.currentTime = this.getCurrentTime();
        break;
      default:
        console.log('[androidPLAYER] antes (default, vod, npvr)', currentTime);
        this.currentTime = Math.floor(currentTime / 1000);
        break;
    }

    if (this.options.events.onTimeUpdate && this.getCurrentPlayerState() !== PONPAUSE) {
      //console.log('[AAF_FWK_STV] [androidPLAYER] _onTimeUpdate regresará ' + this.currentTime);
      this.options.events.onTimeUpdate(this.currentTime);
    }

    this.canStopPlayer = true;
  }

  _onPlaying(e) {
    console.log('[AndroidPlayer] _onPlaying', e);
    if (this.options.events.onPlaying) {
      this.options.events.onPlaying();
    }
  }

  _onBuffering(evt) {
    console.log('[AndroidPlayer] _onBuffering ==>> description:', evt);

    if (evt === 'start') {
      this.onPlayerStateBuffer();
      window.youboraTrackingPlugin && window.youboraTrackingPlugin.getAdapter()._fireBufferBegin();
      if (this.options.events.onBufferingStart) {
        const optionId =  this.options && this.options.audiosubtitleinfo ? this.options.audiosubtitleinfo.optionId : null; 
        if (
          !this.firstLoad ||
          optionId !== this.previousAudio ||
          this.isSeek ||
          this.options.groupId !== this.previousGroupId
        ) {
          this.isBufferingStart = true;
          console.log('Dispatch onBufferingStart ==================> ');
          this.options.events.onBufferingStart(evt);
        }
      }
    }

    if (evt === 'end') {
      // Prevents android to resume when finish buffering
      if (
        this.getCurrentPlayerState() === PONPAUSE &&
        this.currentContentTimeOnPause !== null
      ) {
        //window.AndroidPlayerInterface.pause();
      }

      // If stop and ends buffering, nothing to do
      if (this.getCurrentPlayerState() === PONSTOP) {
        return;
      }

      // If current state is on connecting, then we go to play
      if (this.getCurrentPlayerState() === PONCONNECT) {
        this.onPlayerStatePlay();
      } else {
        // Set same state as last
        this.setCurrentPlayerState(this.previousPlayerState);
      }

      if (this.options.events.onBufferingFinish) {
        window.youboraTrackingPlugin && window.youboraTrackingPlugin.getAdapter()._fireBufferEnd();
        const optionId =  this.options && this.options.audiosubtitleinfo ? this.options.audiosubtitleinfo.optionId : null; 
        if (
          !this.firstLoad ||
          optionId !== this.previousAudio ||
          this.isSeek ||
          this.options.groupId !== this.previousGroupId ||
          this.isBufferingStart
        ) {
          this.options.events.onBufferingFinish(evt);
          this.isBufferingStart = false;
        }
      }

      if (this.androidOnReady) {
        this.androidOnReady = false;
        this._onCanPlay(true);
      }
    }

 

    if (this.options &&
      this.options.audiosubtitleinfo &&
      this.options.audiosubtitleinfo.optionId) {
        this.previousAudio = this.options.audiosubtitleinfo.optionId;
    }

    this.previousGroupId = this.options.groupId;
    this.isSeek = false;
    this.firstLoad = true;
  }

  _onFinished(e) {
    // Si es startover, no debe enviarse el onended
    if (this.options.isStartOver && this.options.isStartOver === true) {
      return;
    }
    // Do destroy to reinit player next play
    this.destroy();

    console.log('[AndroidPlayer] _onFinished');
    console.log(e);
    if (this.options.events.onFinished) {
      this.options.events.onFinished(e);
    }
  }

  _onDurationChange(time) {
    console.log('[AndroidPlayer] _onDurationChange', time);
    this._duration = Math.floor(time / 1000);
    if (this.options.events.onDurationChange) {
      this.options.events.onDurationChange();
    }
  }

  _onSeek(time) {
    if (this.options.events.onBookMark) {
      console.log('Dispatch onBookMark ==================> ');
      this.options.events.onBookMark(time);
    }
  }


  /* END Events */

  /* MULTIPLE AUDIOTRACKS */
  async tryGetAudioTracks(currentTry) {
    console.log('[AndroidPlayer] tryToGetAudioTracks');
    let curTime = this.getCurrentTime();
    if (isNaN(curTime)) {
      curTime = 0;
    }

    if (curTime < 1) {
      console.log('[AndroidPlayer] tryGetAudioTracks retry ', currentTry);
      if (currentTry >= this.retryLimitAudioTrack) {
        throw new Error('Fail to get audioTracks');
      }
      await Utils.sleep(this.retryIntervalAudioTrack);

      return this.tryGetAudioTracks(++currentTry);
    } else {
      console.log(
        '[AndroidPlayer] tryToGetAudioTracks retry number: [' +
        currentTry +
        '] audioTracks READY'
      );

      return this.getAudioTracks();
    }
  }

  getAudioTracks() {
    let curTime = this.getCurrentTime();
    if (isNaN(curTime)) {
      curTime = 0;
    }

    console.info('[AndroidPlayer] ', curTime);
    //if(!this._isOnLoaded) {
    if (curTime < 1) {
      console.info('[AndroidPlayer] Delay 1s to get the audio track info again');
      // ...Start recursive...
      return this.tryGetAudioTracks(1);
    }

    return new Promise(resolve => {
      this.audioTracks = []; // ANDROID does not return info of audioTracks
      resolve(this.audioTracks);
    });
  }

  // @codeTrack iso id i.e.: esp, eng, por, ori
  setAudioTrack(codeTrack) {
    return new Promise((resolve, reject) => {
      console.log('[AndroidPlayer] Enter audioTrack');
      if (this.currentAudioTrackIndex === codeTrack) {
        console.info('[AndroidPlayer] Same audioTrack, nothing to do');
        resolve(true);
      }
      this.currentAudioTrackIndex = codeTrack;
      try {
        console.info('[AndroidPlayer] change audioTrack', codeTrack);
        window.AndroidPlayerInterface.changeSubs(codeTrack, '0');
      } catch (e) {
        console.log('[AndroidPlayer] error when change lang', codeTrack);
        reject('[AndroidPlayer] error when change lang');
      }
      resolve(true);
    });
  }

  // @codeTrack iso id i.e.: esp, eng, por, ori
  setAudioTrackLive(codeTrack, substitleTrack) {
    console.log('[MA-LIVE]----------------------------------------------->setAudioTrackLive');
    if (codeTrack && typeof codeTrack == 'string') {
      // codeTrack = codeTrack.toUpperCase();
    }

    if (substitleTrack && typeof substitleTrack == 'string') {
      // substitleTrack = substitleTrack.toUpperCase();
      if (substitleTrack.toUpperCase() === 'OFF') {
        substitleTrack = null;
      }
    }

    return new Promise((resolve, reject) => {
      console.log('[MA-LIVE] Enter audioTrack');
      this.currentAudioTrackIndex = codeTrack;
      try {
        console.info('[MA-LIVE] change audioTrack ' + codeTrack);
        console.info('[MA-LIVE] change substitleTrack ' + substitleTrack);
        window.AndroidPlayerInterface.changeDubSubTrack(codeTrack, substitleTrack);
      } catch (e) {
        console.log(
          ' +++++++++++++++++++++++++++++++++++++++++++ [MA-LIVE] error when change lang +++++++++++++++++++++++++++++++++++++++++++' +
          e
        );
        reject('[AndroidPlayer] error when change lang');
      }
      resolve(true);
    });
  }

  getAudioSubtitleLive(audioSubtitle) {
    try {
      return JSON.parse(audioSubtitle);
    }
    catch(ex)
    {
      return null;
    }
  }

  /* END MULTIPLE AUDIOTRACKS */

  /**
   * TRICK MODE
   */
  resetFastForwardRewind(frompause) {
    if (typeof frompause === 'undefined') frompause = false;

    this.speed_value = 0;
    if (this.speed_timeoutID) {
      clearTimeout(this.speed_timeoutID);
    }
    this.speed_timeoutID = null;
    this.speed_value = 0;
    this.speed_justNow = false;
    // No importa lo que se settee aquí
    this.speed_direction = false;
    // Event para desaparecer el fastplayback container en caso de que esté en pantalla
    this._onRateChange({ speed: 0, direction: 'BACKWARD', frompause });
  }

  setSpeed(direction) {
    if (this.isSeek) {
      return;
    }

    super.setSpeed(direction);
  }

  setPlayerSpeed(speed) {
    if (this.isSeek) {
      return;
    }

    // console.log('[SPEED PLAYER] Enter setPlayerSpeed ' + speed + ' - '  + this.speed_direction);
    // console.log('[SPEED PLAYER] Enter setPlayerSpeed num 2 ' + speed);
    let androidSpeed = speed;
    if (androidSpeed === 0) {
      androidSpeed = 1;
      // Reset Values
      this.resetFastForwardRewind(false);
    }
    window.AndroidPlayerInterface.changePlaybackSpeed(androidSpeed);
    //console.log('[SPEED PLAYER]Enter setPlayerSpeed before event onRateChange');
    this._onRateChange({
      speed: speed,
      direction: this.speed_direction ? 'FORWARD' : 'BACKWARD'
    });
  }

  setFakePGMGroup() {
    return  {
      common: {
        position: 0,
        id: '590982',
        title: '',
        description: '',
        large_description: '',
        duration: '',
        image_large_alt: '',
        image_medium_alt: '',
        image_small_alt: '',
        image_large: '',
        image_medium: '',
        image_small: '',
        image_still: '',
        image_background: '',
        image_base_horizontal: '',
        image_base_vertical: '',
        image_base_square: '',
        image_clean_horizontal: '',
        image_clean_vertical: '',
        image_clean_square: '',
        image_sprites: '',
        image_frames: '',
        date: '14/06/2019',
        media_type: '2',
        title_uri: 'Hancock',
        extendedcommon: {
          keywords: { keyword: ['5123', '5421'] },
          genres: {
            genre: [
              { id: '51131', name: 'Action', desc: 'Acción' },
              { id: '51105', name: 'Drama', desc: 'Drama' }
            ]
          },
          roles: {
            role: [
              {
                id: '13617516',
                name: 'Actor',
                desc: 'Actor',
                talents: {
                  talent: [
                    {
                      id: '13651382',
                      name: 'Will',
                      surname: 'Smith',
                      fullname: 'Smith, Will'
                    },
                    {
                      id: '13641804',
                      name: 'Charlize',
                      surname: 'Theron',
                      fullname: 'Theron, Charlize'
                    },
                    {
                      id: '13663831',
                      name: 'Jason',
                      surname: 'Bateman',
                      fullname: 'Bateman, Jason'
                    },
                    {
                      id: '13659311',
                      name: 'Thomas',
                      surname: 'Lennon',
                      fullname: 'Lennon, Thomas'
                    },
                    {
                      id: '22051760',
                      name: 'Jae',
                      surname: 'Head',
                      fullname: 'Head, Jae'
                    },
                    {
                      id: '138673565',
                      name: 'David',
                      surname: 'Mattey',
                      fullname: 'Mattey, David'
                    },
                    {
                      id: '13618402',
                      name: 'Johnny',
                      surname: 'Galecki',
                      fullname: 'Galecki, Johnny'
                    },
                    {
                      id: '66035971',
                      name: 'Eddie',
                      surname: 'Marsan',
                      fullname: 'Marsan, Eddie'
                    }
                  ]
                }
              },
              {
                id: '13617517',
                name: 'Director',
                desc: 'Director',
                talents: {
                  talent: [
                    {
                      id: '13625367',
                      name: 'Peter',
                      surname: 'Berg',
                      fullname: 'Berg, Peter'
                    }
                  ]
                }
              },
              {
                id: '13965645',
                name: 'Producer',
                desc: 'Productor',
                talents: {
                  talent: [
                    {
                      id: '100348292',
                      name: 'Akiva',
                      surname: 'Goldsman',
                      fullname: 'Goldsman, Akiva'
                    },
                    {
                      id: '87781468',
                      name: 'James',
                      surname: 'Lassiter',
                      fullname: 'Lassiter, James'
                    },
                    {
                      id: '13651382',
                      name: 'Will',
                      surname: 'Smith',
                      fullname: 'Smith, Will'
                    },
                    {
                      id: '13635987',
                      name: 'Michael',
                      surname: 'Mann',
                      fullname: 'Mann, Michael'
                    }
                  ]
                }
              }
            ]
          },
          format: {
            id: '42223249',
            name: 'Type 6',
            types: 'susc',
            sell_type: 'susc',
            est: 'N'
          },
          media: {
            originaltitle: 'Hancock',
            description_extended: '',
            publishyear: '2008',
            boxoffice: '227.95000000000002',
            rating: {
              id: '30',
              code: 'PG-13',
              desc: 'Apta para mayores de 13'
            },
            duration: '01:32:13',
            haspreview: 'true',
            countryoforigin: { code: 'US', desc: 'Estados Unidos' },
            profile: {
              audiotype: 'Stereo',
              videotype: 'Color',
              screenformat: '16:9',
              hd: { enabled: 'true', detail: '720p' }
            },
            islive: '0',
            livetype: null,
            liveref: null,
            channel_number: null,
            timeshift: null,
            encoder_tecnology: { id: null, desc: null },
            recorder_technology: { id: null, desc: null },
            resource_name: null,
            rollingcreditstime: '-30',
            rollingcreditstimedb: null,
            proveedor: { id: '1', codigo: 'amco', nombre: 'AMCO' },
            rights: { start_date: '2019-06-01', end_date: '2020-05-31' },
            language: {
              original: { id: 'ING', desc: 'Inglés' },
              dubbed: 'true',
              subbed: 'true',
              options: {
                option: [
                  {
                    group_id: '590982',
                    content_id: '694117',
                    current_content: 'false',
                    option_id: 'S-ES',
                    audio: 'ORIGINAL',
                    subtitle: 'ES',
                    option_name: 'subbed',
                    id: 'ES',
                    desc: 'Español',
                    label_short: 'Subt. Español',
                    label_large: 'Subtitulada al Español',
                    intro_start_time: null,
                    intro_finish_time: null,
                    credits_start_time: '-30',
                    encodes: [
                      'hls',
                      'hlsfps',
                      'hlsprm',
                      'est_sd',
                      'est_hd',
                      'smooth_streaming',
                      'dashpr',
                      'dashwv'
                    ],
                    fast_play: []
                  },
                  {
                    group_id: '590982',
                    content_id: '694118',
                    current_content: 'false',
                    option_id: 'S-PT',
                    audio: 'ORIGINAL',
                    subtitle: 'PT',
                    option_name: 'subbed',
                    id: 'PT',
                    desc: 'Portugués',
                    label_short: 'Subt. Portugués',
                    label_large: 'Subtitulada al Portugués',
                    intro_start_time: null,
                    intro_finish_time: null,
                    credits_start_time: '-30',
                    encodes: [
                      'hls',
                      'hlsfps',
                      'hlsprm',
                      'est_sd',
                      'est_hd',
                      'smooth_streaming',
                      'dashpr',
                      'dashwv'
                    ],
                    fast_play: []
                  },
                  {
                    group_id: '590982',
                    content_id: '850391',
                    current_content: 'false',
                    option_id: 'O-EN',
                    audio: 'ORIGINAL',
                    subtitle: null,
                    option_name: 'original',
                    id: 'EN',
                    desc: 'Inglés',
                    label_short: 'Id. Inglés',
                    label_large: 'Idioma Original Inglés',
                    intro_start_time: null,
                    intro_finish_time: null,
                    credits_start_time: '-340',
                    encodes: [
                      'hls',
                      'hlsfps',
                      'hls_ma',
                      'hlsfps_ma',
                      'hlsprm',
                      'smooth_streaming',
                      'smooth_streaming_ma',
                      'dashpr',
                      'dashwv',
                      'dashwv_ma',
                      'dashpr_ma'
                    ],
                    fast_play: []
                  },
                  {
                    group_id: '590982',
                    content_id: '850392',
                    current_content: 'false',
                    option_id: 'D-ES',
                    audio: 'ES',
                    subtitle: null,
                    option_name: 'dubbed',
                    id: 'ES',
                    desc: 'Español',
                    label_short: 'Dob. Español',
                    label_large: 'Doblada al Español',
                    intro_start_time: null,
                    intro_finish_time: null,
                    credits_start_time: '-340',
                    encodes: [
                      'hls',
                      'hlsfps',
                      'hls_ma',
                      'hlsfps_ma',
                      'hlsprm',
                      'smooth_streaming',
                      'smooth_streaming_ma',
                      'dashpr',
                      'dashwv',
                      'dashwv_ma',
                      'dashpr_ma'
                    ],
                    fast_play: []
                  },
                  {
                    group_id: '590982',
                    content_id: '850393',
                    current_content: 'false',
                    option_id: 'D-PT',
                    audio: 'PT',
                    subtitle: null,
                    option_name: 'dubbed',
                    id: 'PT',
                    desc: 'Portugués',
                    label_short: 'Dob. Portugués',
                    label_large: 'Doblada al Portugués',
                    intro_start_time: null,
                    intro_finish_time: null,
                    credits_start_time: '-340',
                    encodes: [
                      'hls',
                      'hlsfps',
                      'hls_ma',
                      'hlsfps_ma',
                      'hlsprm',
                      'smooth_streaming',
                      'smooth_streaming_ma',
                      'dashpr',
                      'dashwv',
                      'dashwv_ma',
                      'dashpr_ma'
                    ],
                    fast_play: []
                  }
                ],
                count: 5
              }
            }
          }
        },
        ranking: { views_count: 798106, votes_count: 6838, average_votes: 4 }
      }
    };
  }

}

export default AndroidPlayer;



// WEBPACK FOOTER //
// ./src/devices/android/Player.js